export const TECHNICAL_ERROR_ROUTE = '_technical_error';
export const PROFESSIONALS_CONNECTION_PATH = 'professionnel/choisir-espace';
export const AGENCY_DETAILS_PATH = 'agence-banque/:agencyIdName';
